import { Stack, Typography, Grid, Box } from "@mui/material";
import theme from "@/theme/theme";
import QrCard from "./qrCard";

const STEPS = [
    {
        title: "Analyse",
        description: "Build PQC knowledge on your critical chains: algorithm response, resource usage, benchmarking.",
    },
    {
        title: "Inventory: Crypto BOM",
        description: "Map cryptography across OS, middleware, networks, software, libraries, plugins and hardware. Establish critical chains.",
    },
    {
        title: "Crypto agility",
        description: "Automate the crypto chain so certificates and key material can be replaced quickly, both now and at every migration that follows.",
    },
    {
        title: "Market & supplier analysis",
        description: "Surface supplier roadmaps and quantum-safe products. Put PQC requirements in tenders and contracts.",
    },
    {
        title: "Impact on your landscape",
        description: "Determine which systems and processes are affected by the PQC transition, and in what order.",
    },
    {
        title: "Migration roadmaps",
        description: "Risk-based, value-based or outside-in. Dependencies mapped, impact on operations assessed, planning set.",
    },
    {
        title: "No-regret measures",
        description: "TLS 1.2 to TLS 1.3 migration. Enable ML-KEM key exchange wherever it is already possible.",
    },
    {
        title: "Chain partners & governance",
        description: "Build cooperation with chain partners and government. Set up governance for a coordinated transition.",
    },
];

const QrProcess = () => {
    return (
        <Stack
            width={{ xs: "100%", lg: "80%" }}
            marginX="auto"
            paddingX={4}
            gap={6}
            position="relative"
        >
            <Stack gap={2} width={{ xs: "100%", lg: "70%" }}>
                <Typography variant="h3" component="h3" className="chno" fontWeight={400} textTransform="uppercase" fontSize={{ xs: "1.3rem !important", lg: "1.75rem !important" }}>
                    How we approach it
                </Typography>
                <Typography variant="body2" component="p" fontSize="0.95rem !important" color={theme.palette.text.secondary} fontWeight={400}>
                    Eight steps, from knowledge and inventory to transition and governance. The approach
                    follows what is used across Dutch government and the ETSI three-phase migration model.
                </Typography>
            </Stack>
            <Grid container spacing={3}>
                {STEPS.map((step, i) => (
                    // The first step spans two columns as an entry point into the
                    // sequence, breaking the uniform 8-card grid.
                    <Grid key={step.title} size={{ xs: 12, sm: 6, lg: i === 0 ? 6 : 3 }}>
                        <QrCard>
                            <Stack gap={1} position="relative" height="100%">
                                <Box sx={{
                                    position: "absolute",
                                    top: -26,
                                    right: -8,
                                    opacity: 0.16,
                                }}>
                                    <Typography component="span" className="chno" fontWeight={600} fontSize="4rem !important" color={theme.palette.brand.mgsLightBlue1.main}>
                                        {String(i + 1).padStart(2, "0")}
                                    </Typography>
                                </Box>
                                <Typography variant="h6" component="h6" fontWeight={400} fontSize="1rem !important" sx={{ position: "relative", zIndex: 1 }}>
                                    {step.title}
                                </Typography>
                                <Typography variant="body2" component="p" fontSize="0.85rem !important" color={theme.palette.text.secondary} fontWeight={400} sx={{ position: "relative", zIndex: 1 }}>
                                    {step.description}
                                </Typography>
                            </Stack>
                        </QrCard>
                    </Grid>
                ))}
            </Grid>
        </Stack>
    );
};

export default QrProcess;
